import { gql } from '@apollo/client';

export const fetchDistrictFinanceAccessQuery = gql`
  query fetchDistrictFinanceAccess($districtId: String!) {
    districtFinanceOperationAccess(districtId: $districtId)
  }
`;
